export default {
	id: "dark",
	name: "Dark",
	colors: {
		"--theme-foreground": "#DDD",
		"--theme-foreground-muted": "#999",
		"--theme-foreground-against-accent": "#FFF",
		"--theme-background": "#222",
		"--theme-background-muted": "#282828",
		"--theme-border": "#888",
		"--theme-border-muted": "#333",
		"--theme-menu-foreground": "#FFF",
		"--theme-menu-background": "#161A1E",
		"--theme-good": "#65C05A",
		"--theme-bad": "#FF5763",
		"--theme-foreground-against-good": "#FFF",
		"--theme-foreground-against-bad": "#FFF",
	}
};
